jQuery(function($) {
  
  function FAQItems() {
    $(document).on('click', '.faq-title', function(e) {
      var $target = $(e.currentTarget);
      var $faq = $target.closest('.faq-item');
      $faq.toggleClass('active');
    });
  }
  
  function IconsFlickity() {
    $('.section--icons-carousel').flickity({
      contain: true,
      pageDots: true,
      watchCSS: true,
      prevNextButtons: false
    });    
  }
  
  $(document).ready(function() {
    FAQItems();
    IconsFlickity();
  });
  
  
  
  $(window).on( 'load', function () {
    
  });
  
  
  
  $(window).on( 'resize', function () {
    
  });
  
  
  
  
});